import { Col, Row } from 'antd';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/delete-icon.svg';
import IconButton from '../Buttons/IconButton';
import SvgConverter from '../Common/SvgConverter';
import SecondaryLabel from '../Labels/SecondaryLabel';

const SimpleFileList = ({ data, handleDelete, showDeleteButton }) => {
  return (
    <Row gutter={5} className="mb-2" align="middle">
      <Col>
        {data?.url ? (
          <a href={data?.url} target="_blank" rel="file  noreferrer">
            <SecondaryLabel className="f-14 fw-600 text-primary cursor-pointer">
              {data.name ?? data.fileName}
            </SecondaryLabel>
          </a>
        ) : (
          <SecondaryLabel className="f-14 fw-600">{data.name ?? data.fileName}</SecondaryLabel>
        )}
      </Col>
      {showDeleteButton && (
        <Col>
          <IconButton onClick={handleDelete}>
            <SvgConverter className="d-flex mt-3" Icon={DeleteIcon} color="iconDanger" />
          </IconButton>
        </Col>
      )}
    </Row>
  );
};

export default SimpleFileList;
